import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const preReceivedDepositStatusEnum = createEnum({
    DRAFT: ['draft', '草稿', 'default'],
    PENDING_RECEIPT: ['pending_receipt', '待到账', 'orange'],
    PARTIAL_RECEIVED: ['partial_received', '部分到账', 'blue'],
    FULLY_RECEIVED: ['fully_received', '全部到账', 'green'],
    REVIEWING_REFUND: ['reviewing_refund', '退款审核中', 'processing'],
    PENDING_REFUND: ['pending_refund', '待退款', 'orange'],
    PARTIAL_REFUNDED: ['partial_refunded', '部分退款', 'blue'],
    FULLY_REFUNDED: ['fully_refunded', '全部退款', 'cyan'],
    REVIEW_REJECTED: ['review_rejected', '审核拒绝', 'red'],
    CANCELED: ['canceled', '已取消', 'default'],
});
export const PRE_RECEIVED_DEPOSIT_STATUSES = enumValues(preReceivedDepositStatusEnum);
export const PRE_RECEIVED_DEPOSIT_STATUS_LABEL_MAP = enumLabelMap(preReceivedDepositStatusEnum);
//# sourceMappingURL=pre-received-deposit.js.map